<template>
    <section class="l-section l-section--main o-cart">
        <div
            class="l-container l-container--main"
            v-if="customer"
        >
            <offer-tabs />
            <div class="l-row">
                <div class="l-row__column l-row__column--10">
                    <offer-week />
                </div>
                <div class="l-row__column o-cart__featured">
                    <offer-featured-products />
                </div>
            </div>
            <div class="l-row">
                <div class="l-row__column">
                    <offer-cart-summary/>
                </div>
            </div>
            <transition name="fade">
                <div
                    class="o-cart__loader"
                    v-if="offerStatus !== 'idle'"
                >
                    <a-icon icon="Spinner" />
                </div>
            </transition>
        </div>
    </section>
</template>

<script>
import OfferWeek from '@/components/offer/OfferWeek'
import OfferCartSummary from '@/components/offer/OfferCartSummary'
import OfferTabs from '@/components/offer/OfferTabs'
import OfferFeaturedProducts from '@/components/offer/OfferFeaturedProducts'

export default {
    name: 'OfferCart',
    components: {
        OfferWeek,
        OfferCartSummary,
        OfferTabs,
        OfferFeaturedProducts
    },
    metaInfo: {
        title: 'Koszyk'
    },
    computed: {
        customer() {
            return this.$store.getters.customer
        },
        currentAddressId() {
            return this.$store.getters.currentAddressId
        },
        currentWarehouseId() {
            const warehouse = this.$store.getters.customerAddressField(this.currentAddressId, 'warehouse')
            if(typeof warehouse === 'object') {
                return Object.prototype.hasOwnProperty.call(warehouse, 'id') ? warehouse.id : false
            } else {
                return false
            }
        },
        externalSupplier() {
            const warehouse = this.$store.getters.customerAddressField(this.currentAddressId, 'warehouse')
            if(warehouse) {
                return warehouse.external_supplier ? 1 : 0
            } else {
                return 0
            }
        },
        customerAddresses() {
            return this.$store.getters.customerAddresses
        },
        offerSlug() {
            return this.$store.getters.offerSlug
        },
        offerStatus() {
            return this.$store.getters.offerStatus
        }
    },
    methods: {
        handleResize() {
            // on touch redirect to nested route
            if(window.innerWidth <= 1024) {
                this.$router.push({ name: 'offer-cart-mobile-week', params: { address: 0, slug: this.$route.params.slug } })
            }
        }
    },
    mounted() {
        if(this.$route.params.slug !== '') {
            if(this.offerSlug !== this.$route.params.slug) {
                this.$store.dispatch('fetchOffer', this.$route.params.slug)
            }
        } else {
            this.$store.dispatch('addNotification', {
                type: 'danger',
                content: 'Brak poprawnego ifentyfikatora oferty.',
                limit: 0
            })
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    }
}
</script>
